import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SecurityService } from '../security/security.service';

@Injectable({
	providedIn: 'root',
})
export class HelpScoutBeaconService {
	constructor(private securityService: SecurityService) {}

	get loggedInUser() {
		return this.securityService.authFields?.loggedInUser;
	}

	public initBeacon(): void {
		const useSupportSystem = !this.loggedInUser?.agent
			? false
			: !this.loggedInUser.agent.parent
				? this.loggedInUser.agent.useSupportSystem
				: this.loggedInUser.agent.useSupportSystem && this.loggedInUser.agent.parent.useSupportSystem;

		if (useSupportSystem && environment.helpScoutBeaconId) {
			(window as any).Beacon('init', environment.helpScoutBeaconId);
			if (this.loggedInUser) {
				(window as any).Beacon('identify', {
					name: this.loggedInUser.fullName,
					email: this.loggedInUser.email,
					userId: this.loggedInUser.userId,
					agentId: this.loggedInUser.agentId,
					signature: this.loggedInUser.helpScoutSignature,
				});
			}
		} else {
			this.destroyBeacon();
		}
	}

	public openBeacon(beaconPrefill?: { subject: string; body: string }): void {
		if (this.isInitialized()) {
			(window as any).Beacon('on', 'open', () => {
				if (beaconPrefill) {
					(window as any).Beacon('prefill', {
						subject: beaconPrefill.subject,
						text: beaconPrefill.body,
					});
				}
			});
			(window as any).Beacon('on', 'close', () => {
				if (beaconPrefill) {
					(window as any).Beacon('reset');
				}
				(window as any).Beacon('off', 'open');
				(window as any).Beacon('off', 'close');
			});
			(window as any).Beacon('open');
		}
	}

	public destroyBeacon(): void {
		if (this.isInitialized()) {
			(window as any).Beacon('destroy');
		}
	}

	public isInitialized(): boolean {
		return !!(window as any).Beacon('info');
	}
}
